import { InferResult } from 'kysely';
import { datasetQueryBuilder } from '../datasetQueryBuilder';
import { DocumentBaseBaseQueryBuilderParams } from '../datasetQueryBuilder.types';
import { getActualityEmployeeShiftQueryBuilder } from './cteQueryBuilders/actualityEmployeeShiftQueryBuilder';

export type ActualityEmployeeShifts = InferResult<
  ReturnType<typeof getActualityEmployeeShiftsQuery>
>;
export type ActualityEmployeeShift = ActualityEmployeeShifts[number];

export const getActualityEmployeeShiftsQuery = (
  params: DocumentBaseBaseQueryBuilderParams,
) => {
  const query = getActualityEmployeeShiftQueryBuilder(
    params.documentContext,
    datasetQueryBuilder,
  );
  return query;
};
